"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lastOr = lastOr;
exports.default = void 0;

var _iterable = require("../../internal/iterable");

function lastOr(iterable, whenEmpty) {
  if (true && Array.isArray(iterable)) {
    return iterable[iterable.length - 1];
  }

  let _item = whenEmpty;

  for (const item of iterable) {
    _item = item;
  }

  return _item;
}

var _default = (0, _iterable.iterableCurry)(lastOr, {
  reduces: true
});

exports.default = _default;